import MainLayout from "../../layouts/MainLayout/MainLayout";
import { Route, Routes } from "react-router-dom";
import ViewLayout from "../../layouts/ViewLayout/ViewLayout";
import DirectionHome from "../../features/Direction/DirectionHome/DirectionHome";

const Direction = () => {
  return (
    <MainLayout>
      <Routes>
        <Route
          path="/"
          element={
            <ViewLayout
              title="Dirección"
              description="Dashboard estratégico de control global y análisis para toma de decisiones."
              backBtnText="Ir a Dirección"
              withBackButton
            >
              <DirectionHome />
            </ViewLayout>
          }
        />
      </Routes>
    </MainLayout>
  );
};

export default Direction;
